// Luật lọc `sync --all` cho workspace KHÔNG phải loại dev (card #254, vd Avatar DataHub).
//
// Đứng NGAY sau luật "marker mất" và TRƯỚC mọi luật khác: workspace non-dev KHÔNG BAO GIỜ được
// sync — khác `stale`/`open-session` (tạm hoãn) — nên không cần xét version hay phiên Claude
// Code. Tầng I/O (`sync-all-across-registered-workspaces.ts`) gỡ các entry này khỏi registry
// để chữa máy đã bị `status`/`doctor` của bản CLI cũ đăng ký nhầm.
import type {
  WorkspaceDecision,
  WorkspaceFacts,
} from "./plan-sync-all-across-registered-workspaces.js";
import { DEV_WORKSPACE_KIND } from "./read-workspace-marker-kind.js";

/** Trả quyết định `skipped:non-dev-workspace`, hoặc `null` khi workspace là dev (thiếu `kind` = dev). */
export function decideNonDevWorkspaceSkip(facts: WorkspaceFacts): WorkspaceDecision | null {
  const kind = facts.workspaceKind ?? DEV_WORKSPACE_KIND;
  if (kind === DEV_WORKSPACE_KIND) return null;
  return {
    kind: "skipped",
    path: facts.entry.path,
    currentVersion: facts.currentVersion,
    reason: "non-dev-workspace",
    detail: `workspace loại '${kind}' (vd Avatar DataHub) — không sync, đã gỡ khỏi registry`,
  };
}
